import React from 'react'
// import Img from "gatsby-image"
import { injectIntl } from 'react-intl';
// import { useStaticQuery, graphql } from "gatsby"

import Team from '../../../assets/team.svg'
import * as S from './About.styled'

const About = ({ intl, ...props }) => {
  // const [showMatheus, setShowMatheus] = React.useState(false);
  // const [showFernanda, setShowFernanda] = React.useState(false);

  // const images = useStaticQuery(graphql`
  //   query {
  //     matheus: file(relativePath: { eq: "matheus.png" }) {
  //       childImageSharp {
  //         fixed(width: 108) {
  //           ...GatsbyImageSharpFixed
  //         }
  //       }
  //     }
  //     fernanda: file(relativePath: { eq: "fernanda.png" }) {
  //       childImageSharp {
  //         fixed(width: 108) {
  //           ...GatsbyImageSharpFixed
  //         }
  //       }
  //     }
  //   }
  // `)

  return (
    <S.About id="section-about">
      <div className="container">
        <div className="title">{intl.messages.about.title}</div>

        <div className="grid">
          <div className="main-content">
            {Object.keys(intl.messages.about.text).map(index => {
              return <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.about.text[index] }} />
            })}
          </div>
          <div>
            <div className="image-feature">
              <Team style={{ width: 540, height: 384 }} />
            </div>
          </div>
        </div>

        {/* <div className="staff">
          <div className="person">
            <div className="person__picture">
              <Img fixed={images.fernanda.childImageSharp.fixed} />
            </div>
            <div className="person__info">
              <div className="person__info-name">Fernanda Zago</div>
              <div className="person__info-position">{intl.messages.about.staff.zago.position}</div>
              <div className={`person__info-bio ${showFernanda && 'person__info-bio--show'}`} dangerouslySetInnerHTML={{ __html: intl.messages.about.staff.zago.about }} />
              <button onClick={() => setShowFernanda(v => !v)} className={`person__info-readmore ${showFernanda && 'person__info-readmore--hide'}`}>{showFernanda ? intl.messages.about.hide : intl.messages.about.readmore}</button>
            </div>
          </div>
          <div className="person">
            <div className="person__picture">
              <Img fixed={images.matheus.childImageSharp.fixed} />
            </div>
            <div className="person__info">
              <div className="person__info-name">Matheus Nunes</div>
              <div className="person__info-position">{intl.messages.about.staff.nunes.position}</div>
              <div className={`person__info-bio ${showMatheus && 'person__info-bio--show'}`} dangerouslySetInnerHTML={{ __html: intl.messages.about.staff.nunes.about }} />
              <button onClick={() => setShowMatheus(v => !v)} className={`person__info-readmore ${showMatheus && 'person__info-readmore--hide'}`}>{showMatheus ? intl.messages.about.hide : intl.messages.about.readmore}</button>
            </div>
          </div>
        </div> */}
      </div>
    </S.About>
  )
}

export default injectIntl(About);